
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M21.885 14.192a1.219 1.219 0 00-1.536.782 8.023 8.023 0 01-1.964 3.2 8.026 8.026 0 01-5.7 2.357 8.018 8.018 0 01-5.7-2.357l1.696-1.688c.351-.351.288-.736-.147-.856l-6.846-1.712a.547.547 0 00-.676.675l1.717 6.845c.117.435.505.5.857.147l1.686-1.68a10.465 10.465 0 007.418 3.07 10.479 10.479 0 007.419-3.07 10.424 10.424 0 002.556-4.167 1.22 1.22 0 00-.78-1.542zM1.843 10.775a1.219 1.219 0 001.536-.782A8 8 0 015.343 6.8a8.058 8.058 0 0111.39 0l-1.686 1.681c-.351.351-.288.736.147.856l6.85 1.712a.547.547 0 00.676-.675L21 3.532c-.117-.435-.5-.5-.857-.147L18.456 5.07a10.5 10.5 0 00-14.837 0A10.481 10.481 0 001.06 9.24a1.22 1.22 0 00.783 1.535z"}})])])
          )
        }
      }
    